<mat-card class="">
    <mat-card-header class="align-items-center">
        <mat-card-title>Model Parameters</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="row mb-2">
            <div class="col-md-5">
                <p class="text-bold">Regions</p>
                <p class="text-grey">{{params.region}}</p>
            </div>
            <div class="col-md-2">
                <p class="text-bold">Currency</p>
                <p class="text-grey">{{params.currency.name}}</p>
            </div>
            <div class="col-md-2">
                <p class="text-bold"># of companies</p>
                <p class="text-grey">{{params.number_of_companies}}</p>
            </div>
            <div class="col-md-3">
                <p class="text-bold">Rebalancing</p>
                <p class="text-grey">{{params.rebalancing.name}}</p>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12">
                <p class="text-bold">Markets</p>
            </div>
            <div class="col-md-3" *ngFor="let item of params.markets">
                <p class="text-grey">{{item.name}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <p class="text-bold">Sectors</p>
            </div>
            <div class="col-md-3" *ngFor="let item of params.sectors">
                <p class="text-grey">{{item.name}}</p>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<mat-card class="mt-4" *ngIf="companies.length">
    <mat-card-header class="align-items-center">
        <mat-card-title>Exclude Companies</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <table mat-table [dataSource]="dataSource" matSort class="w-100">
            <ng-container matColumnDef="company_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element">
                    {{element.company_name}}
                    <app-popover [company]="element" [currency]="params.currency.name" [hideFreq]="true" (click)="closeOtherCompanies(element)"></app-popover>
                </td>
            </ng-container>
            <ng-container matColumnDef="region_name" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
                <td mat-cell *matCellDef="let element"> {{element.region_name}} </td>
            </ng-container>
            <ng-container matColumnDef="market_name" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Market</th>
                <td mat-cell *matCellDef="let element"> {{element.market_name}} </td>
            </ng-container>
            <ng-container matColumnDef="sector_name" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Sector</th>
                <td mat-cell *matCellDef="let element"> {{element.sector_name}} </td>
            </ng-container>
            <ng-container matColumnDef="market_cap">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Market Cap (M{{params.currency.name}})</th>
                <td mat-cell *matCellDef="let element" class="text-end"> {{element.market_cap|number:'1.0-2'}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator showFirstLastButtons></mat-paginator>
    </mat-card-content>
</mat-card>
